import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/Auth';
import { useRecoilValue } from 'recoil';
import { currentProjectState } from '../../recoil/project';
import { projectHome } from '../../v2/flag';

export default function PublicOutlet() {
    const { isLoggedIn } = useAuth();
    const currentProject = useRecoilValue(currentProjectState);

    // If user is logged in, redirect to their project or projects list
    if (isLoggedIn) {
        if (currentProject?.id) {
            return <Navigate to={projectHome(currentProject.id)} replace />;
        }
        return <Navigate to="/projects" replace />;
    }

    return <Outlet />;
}
